import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../../../features/auth";
import { PATHS } from "../../../routes/paths";
import { highestRole } from "@myapp/contract";
import { SplashScreen } from "../../../layouts/SplashScreen/SplashScreen";

interface Props {
  children: React.ReactNode;
}

export const PublicOnly = ({ children }: Props) => {
  const { isAuthenticated, isInitialized, user } = useAuthStore();

  // Until the initial checkAuth() settles we don't know whether the session is
  // valid — showing the login form here would flash it for already-logged-in users.
  if (!isInitialized) return <SplashScreen />;

  if (!isAuthenticated) return <>{children}</>;

  const highest = user?.roles?.length ? highestRole(user.roles) : null;

  switch (highest) {
    case 'MANAGER':
      return <Navigate to={PATHS.workOrderPage} replace />;
    case 'WORKER':
      return <Navigate to={PATHS.workerCalendar} replace />;
    case 'SUPERUSER':
    case 'DIRECTOR':
      return <Navigate to={PATHS.users} replace />;
    default:
      return <Navigate to={PATHS.workOrderPage} replace />;
  }
};
